import { z } from 'zod';

export const ReprocessTenantSignalImportRawRowsBodySchema = z.object({
  tenantId: z.string().min(1),
});

export type ReprocessTenantSignalImportRawRowsBody = z.infer<
  typeof ReprocessTenantSignalImportRawRowsBodySchema
>;

export const REPROCESS_TENANT_SIGNAL_IMPORT_RAW_ROWS_STATUSES = [
  'STARTED',
  'ALREADY_RUNNING',
] as const;

export const ReprocessTenantSignalImportRawRowsStatusSchema = z.enum(
  REPROCESS_TENANT_SIGNAL_IMPORT_RAW_ROWS_STATUSES,
);

export type ReprocessTenantSignalImportRawRowsStatus = z.infer<
  typeof ReprocessTenantSignalImportRawRowsStatusSchema
>;

export const ReprocessTenantSignalImportRawRowsResponseSchema = z.object({
  status: ReprocessTenantSignalImportRawRowsStatusSchema,
});

export type ReprocessTenantSignalImportRawRowsResponse = z.infer<
  typeof ReprocessTenantSignalImportRawRowsResponseSchema
>;
